import { reformatDate } from './reformatDate'

export const getDateInstance = (date) => {
  const newDate = reformatDate(date)
  const dateInstance = newDate ? new Date(newDate) : new Date(0)
  return dateInstance;
};
